module.exports = __webpack_public_path__ + "img/idea.862f4c44.png";